import React, {useEffect, useState} from 'react'
import {apiClient} from "../../../utils/ApiClient";

type Props = {
    open: boolean
    startCountryId: number | null
    destinationCountryId: number | null
    serviceId: number | null
    initialValue: string | null
    onClose: () => void
    onSaved: () => void
}

export default function CommentModal({
    open,
    startCountryId,
    destinationCountryId,
    serviceId,
    initialValue,
    onClose,
    onSaved,
}: Props) {
    const [value, setValue] = useState<string>('')
    const [saving, setSaving] = useState<boolean>(false)
    const [error, setError] = useState<string>('')

    useEffect(() => {
        if (!open) {
            setValue('')
            setSaving(false)
            setError('')
            return
        }

        setValue(initialValue ?? '')
        setSaving(false)
        setError('')
    }, [open, initialValue])

    const close = () => {
        if (saving) return

        onClose()
    }

    const save = async () => {
        if (!startCountryId || !destinationCountryId || !serviceId) {
            console.error('Missing route comment data', {
                startCountryId,
                destinationCountryId,
                serviceId,
            })

            setError('Puuduvad vajalikud andmed kommentaari salvestamiseks.')
            return
        }

        try {
            setSaving(true)
            setError('')

            await apiClient.post('recommendation-comments', {
                start_country_id: startCountryId,
                destination_country_id: destinationCountryId,
                service_id: serviceId,
                comment: value,
            })

            onSaved()
        } catch (e: any) {
            setError('Kommentaari salvestamine ebaõnnestus.')
        } finally {
            setSaving(false)
        }
    }

    if (!open) return null

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.55)',
                backdropFilter: 'blur(2px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                padding: '24px',
            }}
            onClick={close}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '720px',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    boxShadow: '0 20px 50px rgba(0,0,0,0.35)',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '14px 16px',
                        backgroundColor: '#f7f7f7',
                        borderBottom: '1px solid #e6e6e6',
                    }}
                >
                    <div style={{minWidth: 0}}>
                        <div style={{fontSize: '12px', color: '#666', marginBottom: '2px'}}>
                            Marsruudi kommentaar
                        </div>
                        <div style={{fontSize: '16px', fontWeight: 700, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            Soovituse kommentaar
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={close}
                        style={{
                            padding: '6px 10px',
                            fontSize: '12px',
                            fontWeight: 600,
                            borderRadius: '6px',
                            border: '1px solid #d0d0d0',
                            backgroundColor: '#fff',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        Sulge
                    </button>
                </div>

                <div style={{padding: '16px'}}>

                    <textarea
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        rows={7}
                        style={{
                            width: '100%',
                            resize: 'vertical',
                            padding: '12px',
                            fontSize: '14px',
                            borderRadius: '8px',
                            border: '1px solid #d6d6d6',
                            outline: 'none',
                            boxSizing: 'border-box',
                            backgroundColor: '#fff',
                        }}
                        placeholder="Kommentaar"
                    />

                    {error && (
                        <div style={{marginTop: '10px', color: '#b00020', fontSize: '13px'}}>
                            {error}
                        </div>
                    )}

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                            marginTop: '14px',
                            paddingTop: '12px',
                            borderTop: '1px solid #efefef',
                        }}
                    >
                        <button
                            type="button"
                            onClick={close}
                            disabled={saving}
                            style={{
                                padding: '8px 12px',
                                fontSize: '13px',
                                fontWeight: 600,
                                borderRadius: '8px',
                                border: '1px solid #d0d0d0',
                                backgroundColor: '#fff',
                                cursor: saving ? 'not-allowed' : 'pointer',
                                opacity: saving ? 0.7 : 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            Tühista
                        </button>

                        <button
                            type="button"
                            onClick={save}
                            disabled={saving}
                            style={{
                                padding: '8px 14px',
                                fontSize: '13px',
                                fontWeight: 700,
                                borderRadius: '8px',
                                border: '1px solid #1a5fd0',
                                backgroundColor: '#2a74ff',
                                color: '#fff',
                                cursor: saving ? 'not-allowed' : 'pointer',
                                opacity: saving ? 0.7 : 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {saving ? 'Salvestan...' : 'Salvesta'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}